<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records product-section">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="bg-white border-radius-5 p-5">
                        <div class="card border-0 p-0">
                            <div class="card-body p-0">
                                <div class="row no-gutters">
                                    <div class="col-md-6 pr-3">
                                        <figure class="border-radius-5 text-center d-flex justify-content-center align-items-center p-4 bg-body mb-0">
                                            <img src="../../../../static/website/images/shelcal-image.png" alt="" />
                                        </figure>
                                    </div>
                                    <div class="col-md-6 pl-3 pr-5">
                                        <div class="back">
                                            <a href="#" class="d-flex back align-items-center"><i class="icon icon-chevron-down"></i> Back to List</a>
                                        </div>
                                        <h3>Shelcal HD 12 Tablet (15 Tab)</h3>
                                        <p>Each film-coated tablet contains 1250 mg Calcium Carbonate from an organic source (Powdered Oyster Shell) equivalent to Elemental Calcium 500 mg and Vitamin D3 IP 500 IU.</p>
                                        <div class="pack-size d-flex justify-content-between align-items-center mb-3">
                                            <div class="text-left">
                                                <h3>Pack size</h3>
                                                <p>15 Tablets</p>
                                            </div>
                                            <div class="input-group">
                                                <select>
                                                    <option>15 Tablets</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="rating d-flex justify-content-between align-items-center">
                                            <h4>RATING</h4>
                                            <ul class="d-flex">
                                                <li>
                                                    <a href="#"><i class="icon icon-star"></i></a>
                                                </li>
                                                <li>
                                                    <a href="#"><i class="icon icon-star"></i></a>
                                                </li>
                                                <li>
                                                    <a href="#"><i class="icon icon-star"></i></a>
                                                </li>
                                                <li>
                                                    <a href="#"><i class="icon icon-star"></i></a>
                                                </li>
                                                <li>
                                                    <a href="#"><i class="icon icon-star"></i></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="row no-gutters my-4 product-tab pt-2">
                                    <div class="col-md-12">
                                        <ul class="nav nav-tabs" role="tablist">
                                            <li class="nav-item pl-0"><a class="nav-link active" data-toggle="tab" href="#description-1" role="tab">Description </a></li>
                                            <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#medicine" role="tab">About Medicine</a></li>
                                            <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#effects" role="tab">Side Effects</a></li>
                                        </ul>
                                        <div class="tab-content">
                                            <div class="tab-pane active" id="description" role="tabpanel pb-3">
                                                <div class="row no-gutters">
                                                    <div class="col-md-12 py-3">
                                                        <div class="text-left mb-4">
                                                            <h3>Use of Shelcal HD Tablet :</h3>
                                                            <p class="mb-0">Shelcal HD tablet is used in the treatment and prevention of :</p>
                                                            <ul class="mb-0 Osteoporosis">
                                                                <li>Osteoporosis</li>
                                                                <li>Osteomalacia</li>
                                                                <li>Calcium & Vitamin D3 deficiency.</li>
                                                            </ul>
                                                        </div>
                                                        <div class="text-left mb-4">
                                                            <h3>Usage direction of Shelcal HD Tablet :</h3>
                                                            <p class="mb-0">Shelcal HD tablet should be taken orally.</p>
                                                            <p class="mb-0">Shelcal HD tablet is taken whole with the help of water.</p>
                                                            <p class="mb-0">Do not crush, chew or break the tablet.</p>
                                                            <p class="mb-0">Do not skip or stop the medicine without physician's advise.</p>
                                                            <p class="mb-0">Do not consume more than the prescribed quantity.</p>
                                                        </div>

                                                        <div class="text-left mb-4">
                                                            <h3>Precaution & Related information of Shelcal HD Tablet :</h3>
                                                            <p class="mb-0">If allergic to this medicine inform the physician immediately.</p>
                                                            <p class="mb-0">If find any other complication inform the physician immediately.</p>
                                                            <p class="mb-0">Consult with the physician during pregnancy & lactation.</p>
                                                            <p class="mb-0">Keep out of reach of children.</p>
                                                            <p class="mb-0">Store in a cool & dry place.</p>
                                                        </div>
                                                        <div class="text-left mb-4">
                                                            <h3>How this medicine works:</h3>
                                                            <p class="mb-0">Vitamin D3 helps in the absorption of the calcium within the body and calcium carbonate provides the necessary calcium to the body.</p>
                                                        </div>
                                                        <div class="text-left mb-4">
                                                            <h3>Missed dose instructions:</h3>
                                                            <p class="mb-0">Take this medicine as soon as you remember. However, if it is almost time for your next dose skip the dose and go back to your regular doing schedule.</p>
                                                            <p class="mb-0">Do not double dose to make up for the missed dose.</p>
                                                        </div>
                                                        <div class="text-left mb-4">
                                                            <h3>Storage Instructions:</h3>
                                                            <p class="mb-0">Store this medicine in a cool and dry place away from moisture. Keep the medicine away from the reach of children</p>
                                                        </div>
                                                        <div class="text-left mb-4">
                                                            <h3>Overdose Instructions:</h3>
                                                            <p class="mb-0">Seek emergency treatment or contact your physician in case if you experience any unusual signs and symptoms during the treatment with this medicine.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-pane" id="medicine" role="tabpanel pb-3">
                                                <div class="row no-gutters">
                                                    <div class="col-md-12 py-3">
                                                        <div class="text-left mb-4">
                                                            <h3>How this medicine works:</h3>
                                                            <p class="mb-0">Vitamin D3 helps in the absorption of the calcium within the body and calcium carbonate provides the necessary calcium to the body.</p>
                                                        </div>
                                                        <div class="text-left mb-4">
                                                            <h3>Pregnancy warning:</h3>
                                                            <p class="mb-0">
                                                                Use of this medicine may or may not be recommended for pregnant individuals. However, it is necessary to discuss using this medicine with your doctor if you are
                                                                pregnant or planning to become pregnant before using this medicine. All the risks and benefits should be discussed with the doctor before taking this medicine.
                                                            </p>
                                                        </div>
                                                        <div class="text-left mb-4">
                                                            <h3>Expert Advice:</h3>
                                                            <p class="mb-0">This medicine can be taken with or without food</p>
                                                            <p class="mb-0">Patients suffering from kidney damage are recommended to discuss with your doctor before taking these tablets.</p>
                                                            <p class="mb-0">Patients with decreased parathyroid function can experience irregular serum and urine calcium levels</p>
                                                            <p class="mb-0">It is recommended to consult your doctor if you had a history of kidney stones before taking this medicine.</p>
                                                            <p class="mb-0">Report any side effects experienced immediately to the doctor.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-pane" id="effects" role="tabpanel pb-3">
                                                <div class="row no-gutters">
                                                    <div class="col-md-12 py-3">
                                                        <div class="text-left mb-4">
                                                            <h3>Side effects</h3>
                                                            <ul class="mb-0 Osteoporosis">
                                                                <li>Allergic reaction (Rare)</li>
                                                                <li>Nausea (Less common)</li>
                                                                <li>Fever (Less common)</li>
                                                                <li>Headache (Less common)</li>
                                                                <li>Diarrhea (Less common)</li>
                                                                <li>Constipation (Less common)</li>
                                                                <li>Stomachache (Less common)</li>
                                                                <li>Muscle weakness (Less common)</li>
                                                                <li>Urination difficulties (Less common)</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <router-link class="btn btn-blue Buy-Now" to="/prescription-card">Buy Now</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "prescription-product",
        data() {
            return {};
        },
        created(){
           this.pageName('Add Prescription')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/prescription-product.vue